var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[[_c('span',{staticClass:"secondTitle"},[_vm._v(_vm._s(_vm.fullName(_vm.name,_vm.middleName,_vm.surname,_vm.nameOrder)))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }